import React from "react";
import PageRenderer from "../components/PageRender";

const SistemaAnti = () => {
  return <PageRenderer pageIdentifier="sistema-anti-corruzione-aziende" />;
};

export default SistemaAnti;
